import { defineComponent } from '@vue/composition-api';
import { useI18n } from '@superbet-group/web.lib.vue-utilities';
import __vue_component__ from '../SdsButton/SdsButton.vue.js';

/**
 * @deprecated Use SdsModal instead
 */
var script = defineComponent({
    name: 'Dialog',
    props: {
        cancelLabel: {
            type: String,
            required: false,
            default: 'cancel',
        },
        continueLabel: {
            type: String,
            required: false,
            default: 'continue',
        },
        isCancelVisible: {
            type: Boolean,
            required: false,
            default: true,
        },
        isContinueDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabledClass: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup: function (props) {
        var translate = useI18n().translate;
        var formattedCancelLabel = translate(props.cancelLabel).toLocaleUpperCase();
        var formattedContinueLabel = translate(props.continueLabel).toLocaleUpperCase();
        return {
            formattedCancelLabel: formattedCancelLabel,
            formattedContinueLabel: formattedContinueLabel,
        };
    },
    components: {
        SdsButton: __vue_component__,
    },
});

export default script;
